import { type MRT_Localization } from "material-react-table";

export const MRT_Localization_MR: MRT_Localization = {
  language: "mr",
  actions: "क्रिया",
  and: "आणि",
  cancel: "रद्द करा",
  changeFilterMode: "फिल्टर मोड बदला",
  changeSearchMode: "शोध मोड बदला",
  clearFilter: "फिल्टर साफ करा",
  clearSearch: "शोध साफ करा",
  clearSelection: "निवड साफ करा",
  clearSort: "क्रम साफ करा",
  clickToCopy: "कॉपी करण्यासाठी क्लिक करा",
  copy: "कॉपी",
  collapse: "कोलॅप्स",
  collapseAll: "सर्व कोलॅप्स करा",
  columnActions: "कॉलम क्रिया",
  copiedToClipboard: "क्लिपबोर्डमध्ये कॉपी केले",
  dropToGroupBy: "गट करण्यासाठी {column} वर ड्रॉप करा",
  edit: "संपादन",
  expand: "विस्तार",
  expandAll: "सर्व विस्तार करा",
  filterArrIncludes: "समाविष्ट करते",
  filterArrIncludesAll: "सर्व समाविष्ट करते",
  filterArrIncludesSome: "समाविष्ट करते",
  filterBetween: "दरम्यान",
  filterBetweenInclusive: "समावेशी दरम्यान",
  filterByColumn: "{column} नुसार फिल्टर करा",
  filterContains: "समाविष्ट करते",
  filterEmpty: "रिकामे",
  filterEndsWith: "सह समाप्त होते",
  filterEquals: "समान",
  filterEqualsString: "समान",
  filterFuzzy: "फजी",
  filterGreaterThan: "पेक्षा मोठे",
  filterGreaterThanOrEqualTo: "पेक्षा मोठे किंवा समान",
  filterInNumberRange: "दरम्यान",
  filterIncludesString: "समाविष्ट करते",
  filterIncludesStringSensitive: "समाविष्ट करते",
  filterLessThan: "पेक्षा लहान",
  filterLessThanOrEqualTo: "पेक्षा लहान किंवा समान",
  filterMode: "फिल्टर मोड: {filterType}",
  filterNotEmpty: "रिकामे नाही",
  filterNotEquals: "समान नाही",
  filterStartsWith: "सह सुरू होते",
  filterWeakEquals: "समान",
  filteringByColumn: "{column} नुसार फिल्टरिंग - {filterType} {filterValue}",
  goToFirstPage: "पहिल्या पृष्ठावर जा",
  goToLastPage: "शेवटच्या पृष्ठावर जा",
  goToNextPage: "पुढच्या पृष्ठावर जा",
  goToPreviousPage: "मागील पृष्ठावर जा",
  grab: "पकडा",
  groupByColumn: "{column} नुसार गट करा",
  groupedBy: "नुसार गट केले ",
  hideAll: "सर्व लपवा",
  hideColumn: "{column} कॉलम लपवा",
  max: "कमाल",
  min: "किमान",
  move: "हलवा",
  noRecordsToDisplay: "दाखवण्यासाठी कोणतेही रेकॉर्ड नाही",
  noResultsFound: "कोणतेही परिणाम सापडले नाही",
  of: "चे",
  or: "किंवा",
  pin: "पिन करा",
  pinToLeft: "डावीकडे पिन करा",
  pinToRight: "उजवीकडे पिन करा",
  resetColumnSize: "कॉलम आकार रीसेट करा",
  resetOrder: "क्रम रीसेट करा",
  rowActions: "रो क्रिया",
  rowNumber: "#",
  rowNumbers: "रो नंबर",
  rowsPerPage: "प्रति पृष्ठ रो",
  save: "जतन करा",
  search: "शोधा",
  selectedCountOfRowCountRowsSelected:
    "{selectedCount} मध्ये {rowCount} रो(स) निवडले",
  select: "निवडा",
  showAll: "सर्व दाखवा",
  showAllColumns: "सर्व कॉलम दाखवा",
  showHideColumns: "कॉलम दाखवा/लपवा",
  showHideFilters: "फिल्टर दाखवा/लपवा",
  showHideSearch: "शोध दाखवा/लपवा",
  sortByColumnAsc: "{column} नुसार चढत्या क्रमाने सॉर्ट करा",
  sortByColumnDesc: "{column} नुसार उतरत्या क्रमाने सॉर्ट करा",
  sortedByColumnAsc: "{column} नुसार चढत्या क्रमाने सॉर्ट केले",
  sortedByColumnDesc: "{column} नुसार उतरत्या क्रमाने सॉर्ट केले",
  thenBy: ", नंतर ",
  toggleDensity: "घनता टॉगल करा",
  toggleFullScreen: "पूर्ण स्क्रीन टॉगल करा",
  toggleSelectAll: "सर्व निवड टॉगल करा",
  toggleSelectRow: "रो निवड टॉगल करा",
  toggleVisibility: "दृश्यता टॉगल करा",
  ungroupByColumn: "{column} नुसार गट रद्द करा",
  unpin: "अनपिन करा",
  unpinAll: "सर्व अनपिन करा",
};
